import { render, staticRenderFns } from "./add_month_form.vue?vue&type=template&id=228f24b7"
import script from "./add_month_form.vue?vue&type=script&lang=js"
export * from "./add_month_form.vue?vue&type=script&lang=js"
import style0 from "./add_month_form.vue?vue&type=style&index=0&id=228f24b7&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports